import {StoreStateShape} from '@/redux/store/storeStateTypes';

export const errorBoundarySelector = ({commonUserDataReducer}: StoreStateShape) => commonUserDataReducer?.user?.email;
